import * as React from "react"

export function DialogOverlayProvider({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}

const DialogStackContext = React.createContext<null>(null);

export function DialogLayerProvider({ children }: { children: React.ReactNode }) {
  return (
    <DialogStackContext.Provider value={null}>
      {children}
    </DialogStackContext.Provider>
  );
}

const DialogDepthContext = React.createContext<number>(0);

export function useDialogDepth() {
  return React.useContext(DialogDepthContext);
}

export function DialogDepthProvider({ children }: { children: React.ReactNode }) {
  const currentDepth = React.useContext(DialogDepthContext);
  return (
    <DialogDepthContext.Provider value={currentDepth + 1}>
      {children}
    </DialogDepthContext.Provider>
  );
}

export function useDialogZIndex() {
  const depth = useDialogDepth();
  return {
    overlayZIndex: 60 + depth * 10,
    contentZIndex: 65 + depth * 10,
  };
}

export { DialogDepthContext, DialogStackContext as DialogLayerContext };
